import {
  defaultPlatformRandom1jhqtnj1rulyk as defaultPlatformRandom,
  doubleFromParts27owo70la0v4u as doubleFromParts,
} from './PlatformRandom.mjs';
import {
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
import {
  createThis2j2avj17cvnv2 as createThis,
  toString1pkumu07cwy4m as toString,
} from '../js/coreRuntime.mjs';
import { IllegalArgumentException2asla15b5jaob as IllegalArgumentException } from '../exceptions.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../Unit.mjs';
import { toByte4i43936u611k as toByte } from '../js/numberConversion.mjs';
import { XorWowRandom4dcuf9lla8j1 as XorWowRandom } from './XorWowRandom.mjs';
//region block: imports
var imul = Math.imul;
var clz32 = Math.clz32;
//endregion
//region block: pre-declaration
//endregion
var DefaultClass;
function Default() {
  if (DefaultClass === VOID) {
    class $ extends Random() {
      constructor() {
        return new.target.new_kotlin_random_Random_Default_8g3dj6_k$();
      }
      static new_kotlin_random_Random_Default_8g3dj6_k$() {
        Default_instance = null;
        var $this = this.new_kotlin_random_Random_3b5oio_k$();
        Default_instance = $this;
        $this.defaultRandom_1 = defaultPlatformRandom();
        return $this;
      }
      nextBits_kty4bl_k$(bitCount) {
        return this.defaultRandom_1.nextBits_kty4bl_k$(bitCount);
      }
      nextInt_ujorgc_k$() {
        return this.defaultRandom_1.nextInt_ujorgc_k$();
      }
      nextInt_ak696k_k$(from, until) {
        return this.defaultRandom_1.nextInt_ak696k_k$(from, until);
      }
      nextDouble_s2xvfg_k$() {
        return this.defaultRandom_1.nextDouble_s2xvfg_k$();
      }
      nextBytes_ln07bs_k$(array) {
        return this.defaultRandom_1.nextBytes_ln07bs_k$(array);
      }
      nextBytes_ykc5js_k$(array, fromIndex, toIndex) {
        return this.defaultRandom_1.nextBytes_ykc5js_k$(array, fromIndex, toIndex);
      }
    }
    initMetadataForObject($, 'Default');
    DefaultClass = $;
  }
  return DefaultClass;
}
var Default_instance;
function Default_getInstance() {
  if (Default_instance === VOID)
    Default().new_kotlin_random_Random_Default_8g3dj6_k$();
  return Default_instance;
}
var RandomClass;
function Random() {
  if (RandomClass === VOID) {
    class $ {
      static new_kotlin_random_Random_3b5oio_k$() {
        Default_getInstance();
        return createThis(this);
      }
      nextInt_ujorgc_k$() {
        return this.nextBits_kty4bl_k$(32);
      }
      nextInt_ak696k_k$(from, until) {
        checkRangeBounds(from, until);
        var n = until - from | 0;
        if (n > 0 || n === -2147483648) {
          var tmp;
          if ((n & (-n | 0)) === n) {
            var bitCount = fastLog2(n);
            tmp = this.nextBits_kty4bl_k$(bitCount);
          } else {
            var v;
            do {
              var bits = this.nextInt_ujorgc_k$() >>> 1 | 0;
              v = bits % n | 0;
            }
             while (((bits - v | 0) + (n - 1 | 0) | 0) < 0);
            tmp = v;
          }
          var rnd = tmp;
          return from + rnd | 0;
        } else {
          while (true) {
            var rnd_0 = this.nextInt_ujorgc_k$();
            if (from <= rnd_0 ? rnd_0 < until : false)
              return rnd_0;
          }
        }
      }
      nextDouble_s2xvfg_k$() {
        return doubleFromParts(this.nextBits_kty4bl_k$(26), this.nextBits_kty4bl_k$(27));
      }
      nextBytes_ykc5js_k$(array, fromIndex, toIndex) {
        // Inline function 'kotlin.require' call
        if (!((0 <= fromIndex ? fromIndex <= array.length : false) && (0 <= toIndex ? toIndex <= array.length : false))) {
          var message = 'fromIndex (' + fromIndex + ') or toIndex (' + toIndex + ') are out of range: 0..' + array.length + '.';
          throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message));
        }
        // Inline function 'kotlin.require' call
        if (!(fromIndex <= toIndex)) {
          var message_0 = 'fromIndex (' + fromIndex + ') must be not greater than toIndex (' + toIndex + ').';
          throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message_0));
        }
        var steps = (toIndex - fromIndex | 0) / 4 | 0;
        var position = fromIndex;
        // Inline function 'kotlin.repeat' call
        var inductionVariable = 0;
        if (inductionVariable < steps)
          do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var v = this.nextInt_ujorgc_k$();
            array[position] = toByte(v);
            array[position + 1 | 0] = toByte(v >>> 8 | 0);
            array[position + 2 | 0] = toByte(v >>> 16 | 0);
            array[position + 3 | 0] = toByte(v >>> 24 | 0);
            position = position + 4 | 0;
          }
           while (inductionVariable < steps);
        var remainder = toIndex - position | 0;
        var vr = this.nextBits_kty4bl_k$(imul(remainder, 8));
        var inductionVariable_0 = 0;
        if (inductionVariable_0 < remainder)
          do {
            var i = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            array[position + i | 0] = toByte(vr >>> imul(i, 8) | 0);
          }
           while (inductionVariable_0 < remainder);
        return array;
      }
      nextBytes_ln07bs_k$(array) {
        return this.nextBytes_ykc5js_k$(array, 0, array.length);
      }
      nextBytes_dtk0kg_k$(size) {
        return this.nextBytes_ln07bs_k$(new Int8Array(size));
      }
    }
    initMetadataForClass($, 'Random');
    RandomClass = $;
  }
  return RandomClass;
}
function checkRangeBounds(from, until) {
  // Inline function 'kotlin.require' call
  if (!(until > from)) {
    var message = boundsErrorMessage(from, until);
    throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message));
  }
  return Unit_instance;
}
function fastLog2(value) {
  // Inline function 'kotlin.countLeadingZeroBits' call
  return 31 - clz32(value) | 0;
}
function boundsErrorMessage(from, until) {
  return 'Random range is empty: [' + toString(from) + ', ' + toString(until) + ').';
}
function Random_0(seed) {
  return XorWowRandom().new_kotlin_random_XorWowRandom_ms64yk_k$(seed, seed >> 31);
}
function takeUpperBits(_this__u8e3s4, bitCount) {
  return (_this__u8e3s4 >>> (32 - bitCount | 0) | 0) & (-bitCount | 0) >> 31;
}
//region block: exports
export {
  Default_getInstance as Default_getInstancee1f46otjvolq,
  Random_0 as Random2w0u2xak2xaqi,
  Random as Random24dxadk52mliy,
  takeUpperBits as takeUpperBits23varjnd7v1uz,
};
//endregion

//# sourceMappingURL=Random.mjs.map
